import { Input } from "@rebass/forms";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Box, Flex, Image } from "rebass";
import styled from "styled-components";
import { LoginLayout } from "../layouts/LoginLayout";
import { userActions } from "../logic/actions";
import LoginB2BImage from "../static/images/background-login.jpg";
import facebookLogo from "../static/images/facebook.svg";
import instagramLogo from "../static/images/instagram.svg";
import logoImage from "../static/images/login-logo.svg";
import passwordEye from "../static/images/password-eye.svg";
import pinterestLogo from "../static/images/pinterest.svg";
import twitterLogo from "../static/images/twitter-logo-white.png";
import { getLocalizedString } from "../utils";
import { theme } from "../utils/theme";
import config from "../utils/globalConfig";
import LoginFvl from "../components/common/LoginFvl";
import useResponsive from "../hooks/useResponsive";

const FooterLink = styled(Link)`
  display: inline-block;
  margin-left: 40px;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
`;

const LoginPage = () => {
  const navigate = useHistory();
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();
  const { loggedIn, error } = useSelector((state) => state.authentication);
  const { me } = useSelector((state) => state.yodaStakeholders);
  const [passwordShow, setPasswordShow] = useState(false);

  const { isMobile } = useResponsive();

  useEffect(() => {
    document.getElementById("main.container").style.backgroundColor = "#333";
  }, []);

  useEffect(() => {
    if (loggedIn && me?.role) {
      if (me.role == "Agents") {
        navigate.push("/users/" + me.id);
        localStorage.setItem("selectedAgent", me.id);
      }

      if (me.role == "Customer") {
        navigate.push("/orders/" + me.id);
        localStorage.setItem("selectedCustomer", me.id);
      }

      if (me.role == "CustomerCare") {
        navigate.push("/agents");
        localStorage.removeItem("selectedAgent");
        localStorage.removeItem("selectedCustomer");
      }
    }
  }, [loggedIn, me, navigate]);

  const onSubmit = (data) => {
    dispatch(userActions.login(data.username, data.password));
  };

  function handleEyeClick() {
    setPasswordShow(!passwordShow);
  }

  const renderLeft = () => {
    return <Redirect to="/homepage" />;
  };

  const renderForm = () => {
    return (
      <Flex backgroundColor="#232323" flexDirection={"column"}>
        <div
          className="login-header w-full"
          style={{ paddingTop: "1em", height: "70px", minHeight: "70px" }}
        >
          <Flex
            flexDirection={"row-reverse"}
            justifyContent={["center", null, null, "right"]}
          >
            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://www.facebook.com/HernoSpa/"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={facebookLogo} m={2} height={18}></Image>
            </a>
            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://twitter.com/Herno_official"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={twitterLogo} m={2} height={18}></Image>
            </a>
            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://www.instagram.com/herno_official/"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={instagramLogo} m={2} height={18}></Image>
            </a>
            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://www.pinterest.it/hernospa/"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={pinterestLogo} m={2} height={18}></Image>
            </a>
          </Flex>
        </div>

        <Flex
          width={1}
          flexDirection="column"
          height="calc(100vh - 170px)"
          // minHeight={"600px"}
        >
          <img
            className="self-center w-full"
            src={LoginB2BImage}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            alt="background"
          />

          <Flex
            height={["350px", null, null, 400]}
            width={["80%", null, null, 380]}
            backgroundColor={"#fff"}
            style={{
              position: "absolute",
              margin: "auto",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            }}
            justifyContent={"center"}
            alignItems={["flex-start", null, null, "center"]}
            pt={[50, null, null, 0]}
          >
            <Flex
              style={{
                width: 250,
              }}
              flexDirection="column"
              as="form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Image src={logoImage} width={100} alt="logo" style={{}} />
              <Box
                sx={{
                  marginTop: [30, 55, 55],
                  marginBottom: [20, 20, 20],
                  width: 250,
                  color: "#FFFFFF99",
                }}
              >
                <Input
                  style={{
                    fontSize: "0.8em",
                    background: "#F2F2F2",
                    color: theme.black,
                    border: "1px solid #C2C2C2",
                    width: "250px",
                    height: "40px",
                    borderRadius: "4px",
                    padding: "16px",
                  }}
                  id="username"
                  name="username"
                  ref={register({ required: true })}
                  placeholder="User"
                />
                {errors.username && (
                  <span
                    style={{
                      marginLeft: "16px",
                      fontSize: "0.8em",
                      color: "#707070",
                    }}
                  >
                    This field is required
                  </span>
                )}
                {error && (
                  <span
                    style={{
                      marginLeft: "16px",
                      fontSize: "0.8em",
                      color: "#707070",
                    }}
                  >
                    Wrong Username
                  </span>
                )}
              </Box>
              <Box
                sx={{
                  marginBottom: 40,
                  width: 250,
                  color: "#FFFFFF99",
                  position: "relative",
                }}
              >
                <Input
                  style={{
                    fontSize: "0.8em",
                    background: "#F2F2F2",
                    color: theme.black,
                    border: "1px solid #C2C2C2",
                    width: "250px",
                    height: "40px",
                    borderRadius: "4px",
                    padding: "16px",
                  }}
                  id="password"
                  name="password"
                  type={passwordShow ? "text" : "password"}
                  ref={register({ required: true })}
                  placeholder="Password"
                />
                <Image
                  src={passwordEye}
                  height={24}
                  width={24}
                  alt="show password"
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "10px",
                    cursor: "pointer",
                  }}
                  sx={{ opacity: passwordShow ? 0.4 : 1 }}
                  onClick={handleEyeClick}
                />
                {errors.password && (
                  <span
                    style={{
                      marginLeft: "16px",
                      fontSize: "0.8em",
                      color: "#707070",
                    }}
                  >
                    This field is required
                  </span>
                )}
                {error && (
                  <span
                    style={{
                      marginLeft: "16px",
                      fontSize: "0.8em",
                      color: "#707070",
                    }}
                  >
                    Wrong Password
                  </span>
                )}
              </Box>
              <Flex
                style={{
                  color: theme.white,
                  justifyContent: "flex-end",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#232323",
                    color: "#FFF",
                    textTransform: "uppercase",
                    letterSpacing: "1.6px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    padding: "8px 16px",
                    position: isMobile && "absolute",
                    bottom: "25px",
                    right: "31px",
                  }}
                >
                  {getLocalizedString("Accedi")}
                </button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>

        {!isMobile && (
          <Flex
            p={3}
            style={{
              color: "#fff",
              fontSize: "0.8em",
              lineHeight: "2.5em",
              height: 100,
            }}
            justifyContent="space-between"
          >
            <Flex>
              <Box>
                COPYRIGHT © HERNO S.P.A. {new Date().getFullYear()} – ALL
                RIGHTS RESERVED
              </Box>
            </Flex>
            <Flex>
              <Box mr={3}>
                <Link to="/privacy">PRIVACY</Link>
              </Box>
              <Box>
                <Link to="/cookie">COOKIE</Link>
              </Box>
            </Flex>
          </Flex>
        )}

        {isMobile && (
          <Flex flexDirection="column">
            <Flex
              p={1}
              style={{
                color: "white",
                fontSize: "0.8em",
                lineHeight: "2.5em",
                height: 50,
              }}
              justifyContent="center"
              flexDirection="column"
            >
              <Flex>
                <Box mr={3} paddingLeft="2px">
                  <Link to="/privacy">PRIVACY</Link>
                </Box>
                <Box>
                  <Link to="/cookie">COOKIE</Link>
                </Box>
              </Flex>
            </Flex>
            <Flex
              p={1}
              style={{
                color: "black",
                fontSize: "0.8em",
                lineHeight: "2.5em",
                height: 50,
              }}
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              bg="#fff"
            >
              <Box>
                COPYRIGHT © HERNO S.P.A. {new Date().getFullYear()} – ALL
                RIGHTS RESERVED
              </Box>
            </Flex>
          </Flex>
        )}
      </Flex>
    );
  };

  return config.FVL && !isMobile ? (
    <LoginFvl registerRef={register} />
  ) : (
    <LoginLayout leftContent={renderLeft()} formContent={renderForm()} />
  );
};

export { LoginPage };
